// credit: http://www.javascriptkit.com/javatutors/touchevents2.shtml
export class SwipeDetect {
    constructor(el, dir, callback) {
        this.touchsurface = el;
        this.threshold = 50; //required min distance traveled to be considered swipe
        this.restraint = 100; // maximum distance allowed at the same time in perpendicular direction
        this.allowedTime = 300; // maximum time allowed to travel that distance
        this.handleswipe = callback || function () { };
        this.direction = dir || null;
        this.touchStartListener = this.touchStartHandler.bind(this);
        this.touchEndListener = this.touchEndHandler.bind(this);

        this.addEvents();
    }

    touchStartHandler(e) {
        const touchobj = e.changedTouches[0];
        this.swipedir = 'none';
        this.startX = touchobj.pageX;
        this.startY = touchobj.pageY;
        this.startTime = new Date().getTime();
    }

    touchEndHandler(e) {
        const touchobj = e.changedTouches[0];
        const distX = touchobj.pageX - this.startX;
        const distY = touchobj.pageY - this.startY;
        const elapsedTime = new Date().getTime() - this.startTime;
        if (elapsedTime <= this.allowedTime) {
            if (this.direction === 'horizontal' && Math.abs(distX) >= this.threshold && Math.abs(distY) <= this.restraint) {
                this.swipedir = (distX < 0) ? 'left' : 'right';
                e.preventDefault();
            }
            else if (this.direction === 'vertical' && Math.abs(distY) >= this.threshold && Math.abs(distX) <= this.restraint) {
                this.swipedir = (distY < 0) ? 'up' : 'down';
                e.preventDefault();
            }
        }
        this.handleswipe(this.swipedir);
    }

    addEvents() {
        this.touchsurface.addEventListener('touchstart', this.touchStartListener);
        this.touchsurface.addEventListener('touchend', this.touchEndListener);
    }

    removeEvents() {
        this.touchsurface.removeEventListener('touchstart', this.touchStartListener);
        this.touchsurface.removeEventListener('touchend', this.touchEndListener);
    }
}
